export const getAccountReviewOptions = (
  t: (arg: string, arg2: { time: number }) => string
): { value: string; label: string }[] => {
  const option1 = t('account-review.option.month', { time: 1 });
  const option2 = t('account-review.option.months', { time: 3 });
  const option3 = t('account-review.option.months', { time: 6 });

  return [
    {
      value: 'P1M',
      label: option1,
    },
    {
      value: 'P3M',
      label: option2,
    },
    {
      value: 'P6M',
      label: option3,
    },
  ];
};
